"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/sentinelService',["require", "exports", "controllers/sentinelController"], function (require, exports, sentinelController) {
    "use strict";

    var SentinelService = function () {
        function SentinelService() {
            _classCallCheck(this, SentinelService);
        }

        _createClass(SentinelService, [{
            key: "filters",
            value: function filters(section) {
                return sentinelController.filters({ section: section });
            }
        }, {
            key: "logBaseTileChange",
            value: function logBaseTileChange(tileName) {
                sentinelController.logBaseTileChange({ tileName: tileName });
            }
        }, {
            key: "logEnvironmentChange",
            value: function logEnvironmentChange(environmentName) {
                sentinelController.logEnvironmentChange({ environmentName: environmentName });
            }
        }, {
            key: "logPolicyActivity",
            value: function logPolicyActivity(environmentName, activityType, info, policyId, brokerPolicyId, brokerPolicyholderId, policyholderFullName) {
                sentinelController.logPolicyActivity({
                    environmentName: environmentName,
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    policyholderFullName: policyholderFullName,
                    brokerPolicyholderId: brokerPolicyholderId,
                    activityType: activityType,
                    info: info
                });
            }
        }, {
            key: "logWatchPolicyViewed",
            value: function logWatchPolicyViewed(environment, brokerPolicyId, policyHolderFullName, policyId, newTab) {
                sentinelController.logWatchPolicyViewed({
                    localEnvironment: environment,
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    policyHolderFullName: policyHolderFullName,
                    newTab: newTab
                });
            }
        }, {
            key: "fetchLatestSessions",
            value: function fetchLatestSessions(filters, date, hours) {
                return sentinelController.fetchLatestSessions({ filters: filters, date: date, hours: hours });
            }
        }, {
            key: "fetchActivityForSession",
            value: function fetchActivityForSession(sessionId, filters, date, hours) {
                return sentinelController.fetchActivityForSession({ sessionId: sessionId, filters: filters, date: date, hours: hours });
            }
        }, {
            key: "fetchPolicyActivityForSession",
            value: function fetchPolicyActivityForSession(sessionId, filters, date, hours, policyId) {
                return sentinelController.fetchActivityForSession({ sessionId: sessionId, filters: filters, date: date, hours: hours, policyId: policyId });
            }
        }, {
            key: "fetchPolicyActivities",
            value: function fetchPolicyActivities(filters, date, hours) {
                return sentinelController.fetchPolicyActivities({ date: date, hours: hours });
            }
        }, {
            key: "fetchSessionsForPolicyActivity",
            value: function fetchSessionsForPolicyActivity(filters, brokerPolicyId, environment, date, hours) {
                return sentinelController.fetchSessionsForPolicyActivity({ brokerPolicyId: brokerPolicyId, environment: environment, date: date, hours: hours, filters: filters });
            }
        }, {
            key: "fetchActivityForPolicyInteractionSession",
            value: function fetchActivityForPolicyInteractionSession(sessionId, brokerPolicyId, filters) {
                return sentinelController.fetchActivityForPolicyInteractionSession({ sessionId: sessionId, brokerPolicyId: brokerPolicyId, filters: filters });
            }
        }, {
            key: "fetchLatestSessionsForPolicy",
            value: function fetchLatestSessionsForPolicy(hours, brokerPolicyId, environment) {
                return sentinelController.fetchLatestSessionsForPolicy({ hours: hours, brokerPolicyId: brokerPolicyId, environment: environment });
            }
        }, {
            key: "fetchActivityForPolicySession",
            value: function fetchActivityForPolicySession(sessionId, brokerPolicyId, filters) {
                return sentinelController.fetchActivityForPolicySession({ sessionId: sessionId, filters: filters, brokerPolicyId: brokerPolicyId });
            }
        }, {
            key: "fetchLatestUserSessions",
            value: function fetchLatestUserSessions(hours) {
                return sentinelController.fetchLatestUserSessions({ hours: hours });
            }
        }, {
            key: "fetchLatestDispatchSessions",
            value: function fetchLatestDispatchSessions(hours) {
                return sentinelController.fetchLatestDispatchSessions({ hours: hours });
            }
        }]);

        return SentinelService;
    }();

    return new SentinelService();
});
//# sourceMappingURL=sentinelService.js.map;
